export const ENV = {
  /** URL ของ apps/screen — จอ present ต้องชี้ไปที่ตัวเดียวกับที่ขึ้นจอจริง */
  screenBase: import.meta.env.VITE_SCREEN_BASE ?? "http://localhost:5173",
  build: import.meta.env.VITE_BUILD ?? "dev",
} as const;
